import { AccordionSummary, Box, Chip, Stack, Tooltip, Typography } from "@mui/material"
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

export default function AccordionSummaryAverageTime({ data, config, expanded }) {
    const deltaColor = (value) => {
        if (value > 0) return "success"
        if (value < 0) return "error"
        return "warning"
    }

    return (
        <>
            <AccordionSummary
                sx={{
                    px: 0,
                    "& .MuiAccordionSummary-content": {
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    }
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '98%', }}>
                    <Tooltip title={config.tooltip} placement="top" arrow disableInteractive>
                        <Typography variant="h4" sx={{ cursor: 'help' }}>
                            {config.label}
                        </Typography>
                    </Tooltip>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Chip
                            size="medium"
                            variant="outlined"
                            color={deltaColor(data.delta)}
                            sx={{ mr: 2 }}
                            label={data.delta ? `${data.delta > 0 ? "+" : ""}${data.delta}%` : '0%'}
                        />
                        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 3 }}>
                    <Stack sx={{ justifyContent: 'flex-start', textAlign: 'start' }}>
                        <Typography variant="body1" color="textSecondary">
                            HOJE
                        </Typography>
                        <Typography variant="h2" sx={{ fontWeight: 'bold', fontSize: '30px' }}>
                            {data.hoje ? data.hoje : '00:00:00'}
                        </Typography>
                    </Stack>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Stack sx={{ justifyContent: 'flex-end', textAlign: 'start' }}>
                            <Typography variant="body1" color="textSecondary">
                                ONTEM
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                                {data.ontem ? data.ontem : '00:00:00'}
                            </Typography>
                        </Stack>

                        <Stack sx={{ justifyContent: 'flex-end', textAlign: 'end' }}>
                            <Typography variant="body1" color="textSecondary">
                                MÊS
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                                {data.mes ? data.mes : '00:00:00'}
                            </Typography>
                        </Stack>
                    </Box>
                </Box>
            </AccordionSummary>
        </>
    )
}